import React from "react";
import Image from "../../components/Image";
import LogoMarquee from "../../components/LogoMarquee/LogoMarquee";
import { numData } from "../../content/escrow-account";
import {
  EscrowManagementData,
  allLogoData,
} from "../../constants/escrow-account";

const EscrowManagement = () => {
  return (
    <section className="escrow-mang-bg">
      <div className="container">
        <div className="text-[24px] md:text-[28px] text-white mb-[30px] md:mb-[72px]">
          <h3>Not just any other</h3>{" "}
          <h2 className="inline text-[24px] md:text-[28px]">
            Escrow Management Platform
          </h2>
        </div>
        <div className="flex flex-wrap">
          {EscrowManagementData.map(({ id, img, title, description }) => (
            <div key={id} className="escrow-flex-child !mb-[60px]">
              <Image
                src={img}
                alt={title}
                width="40"
                height="40"
                className="mb-[24px]"
              />
              <p className="text-white font-semibold text-[16px] mb-[8px]">
                {title}
              </p>
              <p className="text-[14px] text-cf-cold-purple max-w-[285px]">
                {description}
              </p>
            </div>
          ))}
        </div>
        <div className="flex text-center justify-around md:mb-[72px] escrow-management-numbers">
          {numData.map(({ id, description, heading }) => (
            <div key={id} className="w-full px-0 md:px-[19px] mb-4 lg:mb-[0px]">
              <div
                className="px-4 py-6 rounded w-full md:w-[395px] md:max-h-[155px] h-[155px] flex items-center justify-center m-auto"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.06)",
                  border: "1px solid #DCDEE654",
                }}>
                <div>
                  <h3 className="font-body font-semibold md:font-semibold mb-2 text-cf-white text-[16px] font-body text-[28px]">
                    {heading}
                  </h3>
                  <div className="text-2sm text-cf-white opacity-80 text-[#A7A2E0]">
                    {description}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mb-[24px]">
          <Image
            src="https://cashfreelogo.cashfree.com/website/landings/escrow-account/dottedLine.png"
            alt="line"
            width="1260"
            height="1"
            style={{ width: "auto", height: "auto" }}
          />
        </div>
        <div className="flex items-center">
          <p className="text-[#F6BF44] md:w-[500px]">Our Merchants:</p>
          <div className="relative overflow-hidden z-[1] custom-escrow-width">
            <LogoMarquee data={allLogoData} imgUrl="" width="130" height="48" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default EscrowManagement;
